import { Component } from '@angular/core';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
})
export class SupportComponent {
  language: 'is' | 'en' = 'is'; // Default to Icelandic

  setLanguage(lang: 'is' | 'en') {
    this.language = lang;
  }
}